import apiClient from "@/axiosConfig";
import { useUxStore } from "@/stores/uxStore";

async function run(request, errorMessage, { silentStatuses = [] } = {}) {
  const uxStore = useUxStore();
  uxStore.startLoading();
  try {
    const response = await request();
    return response.data;
  } catch (error) {
    const isSilent = silentStatuses.includes(error?.response?.status);
    if (!isSilent) {
      console.error(errorMessage, error);
      uxStore.setError(error?.response?.data?.detail || errorMessage);
    }
    throw error;
  } finally {
    uxStore.stopLoading();
  }
}

function odsForm(employeeId, file, additional = {}) {
  const form = new FormData();
  form.append("employeeId", employeeId);
  form.append("file", file);
  Object.entries(additional).forEach(([key, value]) => form.append(key, String(value)));
  return form;
}

export default {
  getMyMonth(year, month) {
    return run(
      () => apiClient.get("/workforce/me/month", { params: { year, month } }),
      "Der Mitarbeitermonat konnte nicht geladen werden.",
      { silentStatuses: [404] }
    );
  },

  getEmployeeMonth(employeeId, year, month) {
    return run(
      () => apiClient.get(`/workforce/employees/${employeeId}/month`, { params: { year, month } }),
      "Der Mitarbeitermonat konnte nicht geladen werden."
    );
  },

  getMyHistory() {
    return run(
      () => apiClient.get("/workforce/me/history"),
      "Die Workforce-Historie konnte nicht geladen werden.",
      { silentStatuses: [404] }
    );
  },

  getEmployeeHistory(employeeId) {
    return run(
      () => apiClient.get(`/workforce/employees/${employeeId}/history`),
      "Die Workforce-Historie konnte nicht geladen werden."
    );
  },

  getEmployees() {
    return run(
      () => apiClient.get("/workforce/employees"),
      "Die Mitarbeiterliste konnte nicht geladen werden."
    );
  },

  recordTime(payload) {
    return run(
      () => apiClient.post("/workforce/me/time", payload),
      "Die Arbeitszeit konnte nicht gespeichert werden."
    );
  },

  recordAllocation(payload) {
    return run(
      () => apiClient.post("/workforce/me/customer-allocations", payload),
      "Die Kundenallokation konnte nicht gespeichert werden."
    );
  },

  getLeaveRequests() {
    return run(
      () => apiClient.get("/workforce/me/leave-requests"),
      "Die Urlaubsanträge konnten nicht geladen werden.",
      { silentStatuses: [404] }
    );
  },

  createLeaveRequest(payload) {
    return run(
      () => apiClient.post("/workforce/me/leave-requests", payload),
      "Der Urlaubsantrag konnte nicht gespeichert werden."
    );
  },

  submitLeaveRequest(requestId) {
    return run(
      () => apiClient.post(`/workforce/me/leave-requests/${requestId}/submit`),
      "Der Urlaubsantrag konnte nicht eingereicht werden."
    );
  },

  cancelLeaveRequest(requestId, reason = null) {
    return run(
      () => apiClient.post(`/workforce/me/leave-requests/${requestId}/cancel`, { reason }),
      "Der Urlaubsantrag konnte nicht storniert werden."
    );
  },

  getApprovals() {
    return run(
      () => apiClient.get("/workforce/approvals"),
      "Das Freigabepostfach konnte nicht geladen werden."
    );
  },

  approve(requestId, payload) {
    return run(
      () => apiClient.post(`/workforce/approvals/${requestId}/approve`, payload),
      "Der Urlaubsantrag konnte nicht freigegeben werden."
    );
  },

  reject(requestId, reason) {
    return run(
      () => apiClient.post(`/workforce/approvals/${requestId}/reject`, { reason }),
      "Der Urlaubsantrag konnte nicht abgelehnt werden."
    );
  },

  previewOds(employeeId, file) {
    return run(
      () => apiClient.post("/workforce/imports/ods/preview", odsForm(employeeId, file)),
      "Die ODS-Vorschau konnte nicht erstellt werden."
    );
  },

  applyOds(employeeId, file, expectedContentHash) {
    return run(
      () => apiClient.post(
        "/workforce/imports/ods/apply",
        odsForm(employeeId, file, { expectedContentHash, explicitlyConfirmed: true })
      ),
      "Der ODS-Import konnte nicht übernommen werden."
    );
  },
};
